import { render, staticRenderFns } from "./ReviewQuote.vue?vue&type=template&id=1f031a65&scoped=true"
import script from "./ReviewQuote.vue?vue&type=script&lang=js"
export * from "./ReviewQuote.vue?vue&type=script&lang=js"
import style0 from "./ReviewQuote.vue?vue&type=style&index=0&id=1f031a65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f031a65",
  null
  
)

export default component.exports